import { getStore } from '~/mobx/AppStore';

// Click from the Report main menu, the left menu inside the Report tab (slag/region)
const handleFetchReportData = () => {
    const { reportStore, generalSettingsStore, regionStore } = getStore();

    const selectedElectionYear = generalSettingsStore.getSelectedElectionYear();

    reportStore.setVotesList([]);

    if (selectedElectionYear) {
        reportStore.getUserVoteCount();
    }

    if (regionStore.selectedRegionId !== '') {
        reportStore.getCandidateScoreListByRegion();
    }
};

export default handleFetchReportData;
